(() => {
  const bindWyshCardClicks = () => {
    if (document.documentElement.dataset.amyannWyshBound === 'true') return;
    document.documentElement.dataset.amyannWyshBound = 'true';

    document.addEventListener(
      'click',
      (event) => {
        const wysh = event.target.closest(
          '.wysh-button, .wysh-list-dropdown-menu-item, .wysh-list-dropdown-wrapper'
        );
        if (!wysh) return;

        const media = wysh.closest('.amyann-furniture-card__media');
        if (!media) return;

        event.preventDefault();
      },
      true
    );
  };

  const bindFinishSwatches = (root) => {
    if (!(root instanceof Element)) return;

    root.querySelectorAll('.amyann-furniture-card').forEach((card) => {
      const previewImg = card.querySelector('[data-furniture-preview-image]');
      if (!previewImg) return;

      const swatches = card.querySelectorAll('.amyann-furniture-finish-swatch');
      swatches.forEach((swatch) => {
        if (swatch.dataset.bound === 'true') return;
        swatch.dataset.bound = 'true';

        swatch.addEventListener('click', () => {
          if (swatch.classList.contains('is-unavailable')) return;

          const img = swatch.dataset.previewImage;
          if (img) previewImg.src = img;

          swatches.forEach((s) => s.classList.remove('is-active'));
          swatch.classList.add('is-active');
        });
      });
    });
  };

  const init = () => {
    bindWyshCardClicks();
    document.querySelectorAll('[data-amyann-furniture-grid-root]').forEach(bindFinishSwatches);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
